import HomePage from '../page-components/LandingPage';
import { hydratePageComponent } from './base-script';

hydratePageComponent(HomePage);
